<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column">
  <oneapp-header
    title="Create task"
    i18n-title="@@createTask"
    (buttonClick)="onActionButtonClick($event)"
    [showSpinner]="isSaving"
    [saveButtonConfig]="saveButtonConfig"
    [customButtonConfig]="cancelButtonConfig"
  ></oneapp-header>
  <div class="form_container" fxLayoutAlign="start stretch" fxLayout="column">
    <form class="task-form" [formGroup]="taskCreationForm">
      <!--Input field with autocomplete for workflows-->
      <div class="formelement_container" fxLayout="row">
        <mat-form-field id="select_workflow" appearance="outline">
          <mat-label
            i18n="label for workflow dropdown field@@workflowDropDownUpperCase"
            class="title-case-label"
            >workflow</mat-label
          >
          <input
            matInput
            appTrimString
            placeholder=""
            [value]="taskCreationForm.controls.workflowSelection.value"
            id="workflow"
            formControlName="workflowSelection"
            [matAutocomplete]="auto"
            (keyup)="isWorkflowLocked ? undefined : debounceWorkflowCheck()"
            (blur)="onWorkflowBlur()"
            [readonly]="isSaving || isWorkflowLocked"
          />
          <mat-error
            *ngIf="taskCreationForm.controls.workflowSelection.errors?.required"
            i18n="error message text@@workflowFieldRequired"
            >Workflow is required</mat-error
          >
          <mat-error
            *ngIf="taskCreationForm.controls.workflowSelection.errors?.invalidWorkflow"
            i18n="error message text@@workflowMustExist"
            >It must be an existing workflow</mat-error
          >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="handleWorkflowSearch()">
            <mat-option *ngFor="let workflow of filteredWorkflows | async" [value]="workflow.name">
              {{ workflow.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!--Task name input -->
      <div class="formelement_container">
        <mat-form-field id="task_name" appearance="outline">
          <mat-label i18n="@@taskNameLabel" class="title-case-label">task name</mat-label>
          <input
            matInput
            appTrimString
            placeholder=""
            formControlName="taskNameSelection"
            id="task_name_input"
            [value]="taskCreationForm.controls.taskNameSelection.value"
            [readonly]="isSaving"
          />
          <button
            matSuffix
            mat-icon-button
            type="button"
            class="reset-icon-button"
            (click)="clearName(); $event.stopPropagation()"
            [disabled]="isSaving || taskCreationForm.controls.taskNameSelection.pristine"
          >
            <fa-icon class="reset-icon" [icon]="faUndo" aria-label="reset task name"></fa-icon>
          </button>
          <mat-error
            *ngIf="taskCreationForm.controls.taskNameSelection.errors?.required"
            i18n="error message text@@nameFieldRequired"
            >Task Name is required</mat-error
          >
        </mat-form-field>
      </div>
      <!--employee dropdown-->
      <div class="formelement_container" fxLayout="row">
        <mat-form-field appearance="outline">
          <mat-label i18n="@@assignedToLabel" class="title-case-label">assigned to</mat-label>
          <mat-select
            id="employee_dropdown"
            formControlName="employeeSelection"
            [(value)]="employeeID"
            [disabled]="isSaving"
          >
            <div class="select-heading">
              <fa-icon
                class="icon icon-md"
                [icon]="faUsers"
                aria-label="user settings button"
              ></fa-icon>
              <span i18n="@@employeeGroupsLabel">Employee Groups</span>
            </div>
            <mat-option
              class="select-option"
              *ngFor="let employeeGroup of employeeGroups"
              [value]="employeeGroup.employeeGroupId"
              (click)="setEmployeeGroup()"
            >
              {{ employeeGroup.name }}
            </mat-option>
            <div class="select-heading">
              <fa-icon
                class="icon icon-md"
                [icon]="faUser"
                aria-label="user settings button"
              ></fa-icon>
              <span i18n="@@employeesLabel">Employees</span>
            </div>

            <mat-option
              class="select-option"
              *ngFor="let employee of employees"
              [value]="employee.employeeId"
              (click)="setEmployee()"
            >
              {{ employee.userName }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="taskCreationForm.controls.employeeSelection.errors?.required"
            i18n="error message text@@assignedToFieldRequired"
            >Assigned to is required</mat-error
          >
        </mat-form-field>
      </div>
      <div *ngIf="executableFromMobile === true && showRef === true">
        <br />
        <h3 i18n="@@referenceLabel">Reference</h3>
        <div class="formelement_container" fxLayout="row">
          <mat-form-field id="task_name" appearance="outline">
            <mat-label>{{ referenceName }}</mat-label>
            <input
              matInput
              appTrimString
              placeholder=""
              formControlName="referenceSelection"
              id="reference_input"
              [value]="taskCreationForm.controls.referenceSelection.value"
            />
          </mat-form-field>
          <button
            id="appand-to-task-name-btn"
            mat-flat-button
            color="primary"
            class="append-reference-button"
            (click)="appendToTaskName()"
            [disabled]="isSaving || validateReferenceValue()"
          >
            <span i18n="@@appendToTaskName">Append to task name</span>
          </button>
        </div>
      </div>

      <!-- task scheduling -->
      <oneapp-task-manager-scheduling [locked]="isSaving"></oneapp-task-manager-scheduling>

      <!-- task attachments -->
      <div class="file-area">
        <p class="section-title" i18n="@@attachments">Attachments</p>
        <p class="section-text" i18n="@@attachmentDescription">
          You can add attachments that will be available during task execution.
        </p>

        <button
          mat-stroked-button
          class="file-upload-button"
          (click)="fileInput.click()"
          [disabled]="!fileUploadEnabled || isSaving"
        >
          <input
            #fileInput
            type="file"
            (change)="onFileSelected($event)"
            accept="{{ valid_file_extensions }}"
            hidden
            multiple
          />
          <fa-icon class="file-upload-button-icon" [icon]="faPaperclip"></fa-icon>
          <span class="file-upload-button-text" i18n="@@attachmentAddFile">Add File</span>
        </button>

        <mat-chip-set *ngIf="files.length > 0">
          <mat-chip
            [disableRipple]="true"
            *ngFor="let file of files"
            class="file-attachment-chip noselect"
            (removed)="removeFile(file)"
          >
            {{ file.name }}
            <button matChipRemove [disabled]="isSaving">
              <fa-icon [icon]="faX"></fa-icon>
            </button>
          </mat-chip>
        </mat-chip-set>

        <div *ngIf="fileErrors.length > 0" class="file-error-area">
          <p class="file-error-title">
            <fa-icon [size]="'lg'" class="warning-icon" [icon]="faWarning"></fa-icon>
            <b i18n="@@attachmentError">Error</b>
            <fa-icon class="clear-errors" [icon]="faX" (click)="clearFileUploadErrors()"></fa-icon>
          </p>
          <p class="file-error-entry" *ngFor="let fileError of fileErrors">
            {{ fileError.fileName }}
            <b>{{ fileError.error }}</b>
          </p>
        </div>
      </div>
    </form>
  </div>
</div>
